import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const ExpandableStyles = css(
    ({ theme: { spacing, palette, borderRadius, border } }) => css`
        .Expandable {
            border: ${border.sm};
            transition: background-color 0.2s, border-radius 0.2s;

            .Typography {
                transition: color 0.1s;
            }
            .ExpandableDisplay {
                padding: ${spacing.all(4, 5)};
                border-bottom: none;
                ${getTypographyStyle("body2Medium")}
            }
            .ExpandableBody {
                padding: 0;
            }
            .ExpandableContent {
                padding: ${spacing.all(1, 5, 4, 5)};
            }
            &.Open {
                background-color: ${palette.primary};
                color: ${palette.white};
                border-radius: ${borderRadius};
                border: none;
                //This styles has been harcoded in order to properly display with the animation.
                .ExpandableDisplay {
                    padding: 1.1rem 1.35rem 0 1.35rem;
                }
                .ExpandableContent {
                    padding: 0 1.35rem 1.1rem 1.35rem;
                }
            }
        }
    `,
);
